<template>
  <div class="parkingcore">
    <div class="header">
      <div class="title">核心功能</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="right">
            <img :src="item.logo" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import parkingcore1 from "../../../../assets/programme/parkingcore1.png";
import parkingcore2 from "../../../../assets/programme/parkingcore2.png";
import parkingcore3 from "../../../../assets/programme/parkingcore3.png";
import parkingcore4 from "../../../../assets/programme/parkingcore4.png";
import parkingcore5 from "../../../../assets/programme/parkingcore5.png";
import parkingcore6 from "../../../../assets/programme/parkingcore6.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "车位管理",
          text: "所有车位，后台统一管理，有无车位一键查阅；车位被占、被挡无须担心，一键联系车主解决问题，方便迅捷。",
          logo: parkingcore1,
        },
        {
          id: 2,
          title: "无人值守",
          text: "车辆驶出驶入，无需专人值守，车闸智能识别，省时省力。",
          logo: parkingcore2,
        },
        {
          id: 3,
          title: "临时停缴",
          text: "临时停车，智能统计，一键缴费，安全便携。",
          logo: parkingcore3,
        },
        {
          id: 4,
          title: "无感支付",
          text: "系统后台智能结算停车时长，无需手动缴费，无感支付，方便快捷，资金直达物业，保障资金安全。",
          logo: parkingcore4,
        },
        {
          id: 5,
          title: "预约停车",
          text: "需要停车，随时随地一键预约，预留车位，随到随停。",
          logo: parkingcore5,
        },
        {
          id: 6,
          title: "车位定位",
          text: "闲置车位一键查询，智能定位，导航直达，不再需要主动寻找停车位，提升业主满意度。",
          logo: parkingcore6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.parkingcore {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  width: 162px;
  display: flex;
  margin-bottom: 40px;
  text-align: center;
}
.body .list .item .right img {
  width: 36px;
}
.body .list .item .right .title {
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
  color: #333;
}
.body .list .item .right .text {
  font-size: 12px;
  margin-top: 8px;
  color: #495a6c;
}
</style>
